export default __webpack_public_path__ + "assets/a0308450309b1310ea50f14564ae44ca.jpg";